import * as React from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "./style/style.scss";

interface IState {
  index: number;
}

export default class VideoPlayer extends React.Component<any, IState> {
  private player: any;
  private videoDom: any;

  constructor(props: any) {
    super(props);
    this.state = {
      index: this.props.index
    };
  }

  public componentWillReceiveProps(nextProps: any) {
    if (nextProps.index !== this.state.index) {
      this.setState({
        index: nextProps.index
      });
      console.log("sources", this.props.sources);
      this.player.src(this.props.sources[nextProps.index].src);
    }
  }

  public componentDidMount() {
    const { sources, option } = this.props;
    const { index } = this.state;
    console.log("index", index);

    // instantiate Video.js
    this.videoDom.setAttribute("playsinline", true);
    this.videoDom.setAttribute("webkit-playsinline", true);
    this.videoDom.setAttribute("x5-playsinline", true);
    this.videoDom.setAttribute("x5-video-player-type", "h5");
    this.videoDom.setAttribute("x5-video-player-fullscreen", false);

    this.player = videojs(this.videoDom, option, function onPlayerReady(this: any) {
      this.src(sources[index || 0].src);
    });
  }

  // destroy player on unmount
  public componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  public render() {
    return (
      <div className="vjs-custom-skin vjs-custom-mp4">
        <video className="video-js" ref={node => (this.videoDom = node)} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pc/component/videoPlayer/videoMp4.tsx